export default __webpack_public_path__ + "static/media/BlackSpinner.2c537a24.svg";